import { render } from "./VaPageNotFound.vue?vue&type=template&id=5d13dd90"
import script from "./VaPageNotFound.vue?vue&type=script&lang=js"
export * from "./VaPageNotFound.vue?vue&type=script&lang=js"

import "./VaPageNotFound.vue?vue&type=style&index=0&id=5d13dd90&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__